// extracted by mini-css-extract-plugin
export default {"root":"Panel3_root_r8V8I"};